// Аванс человека в ведомости: этот месяц и перенесённый из прошлых.
//
// 12.10.2026 финансовый директор заказчика: «перенесённые неудержанные авансы уменьшают сумму
// к выплате, но в самой ведомости колонка „Аванс“ показывает ноль, а в шапке они идут как
// прочие удержания». У 82 человек сентября это 949 427 ₽.
//
// ## Откуда два числа
//
// Аванс этого месяца (`advance_total`) удерживается шагом 3, сразу после официальной части.
// Неудержанный аванс прошлых месяцев приходит долгом и удерживается вместе с долгами, но
// сервер кладёт его в ту же колонку «Аванс», сверх аванса месяца. Значит в колонке лежит сумма
// обоих, а перенесённое — это её превышение над авансом месяца.
//
// При обнулении каскадом долги не удерживаются вовсе, и в колонке ровно аванс месяца: превышения
// нет, перенесённого ноль.

import type { PayrollEmployeeOut } from '@/shared/api/endpoints/payroll';
import { COLUMN_ADVANCE } from '@/shared/api/endpoints/payroll';

type Человек = Pick<PayrollEmployeeOut, 'advance_total' | 'amounts'>;

/** Всё, что лежит в колонке «Аванс»: аванс месяца и перенесённый из прошлых месяцев. */
export function авансВКолонке(человек: Человек): number {
  return Math.max(человек.amounts?.[COLUMN_ADVANCE] ?? 0, человек.advance_total);
}

/** Неудержанный аванс прошлых месяцев, удержанный в этом расчёте. */
export function перенесённыйАванс(человек: Человек): number {
  return авансВКолонке(человек) - человек.advance_total;
}
